import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { headerTitles } from "../../actions/masterdata/masterdata";

const FreeCreditScore = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      headerTitles({
        title: "Free Credit Score",
        description: "",
      })
    );
  }, []);
  return <div>FreeCreditScore</div>;
};

export default FreeCreditScore;
